/**
 * @generated SignedSource<<555264871f0c04d9327243387b81f043>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AcceptFinalCheckMutation$variables = Record<PropertyKey, never>;
export type AcceptFinalCheckMutation$data = {
  readonly acceptFinalCheck: {
    readonly id: string;
    readonly tradingActive: boolean;
  } | null | undefined;
};
export type AcceptFinalCheckMutation = {
  response: AcceptFinalCheckMutation$data;
  variables: AcceptFinalCheckMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tradingActive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptFinalCheckMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "acceptFinalCheck",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AcceptFinalCheckMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "acceptFinalCheck",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "afa94ce61a2b2712c2ab7474cab6c466",
    "id": null,
    "metadata": {},
    "name": "AcceptFinalCheckMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptFinalCheckMutation {\n  acceptFinalCheck {\n    __typename\n    id\n    tradingActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "438392103446be059536868529fc8f04";

export default node;
